import React, { useState } from 'react'
import './Navbar.css'
import logo from '../../assets/logo.png'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import underline from '../../assets/theme.png';
import { FaBars } from 'react-icons/fa'
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const [menu, setMenu] = useState("home");
  return (
    <>
      <div className="topbar">

      <div className="hamburger" onClick={toggleSidebar}>
        <FaBars />
      </div>
        <img src={logo} alt="" itemID='logo' className='fixed-logo' />
      </div>

    
      <div className={`navbar ${isOpen ? 'open' : 'closed'}`}>
        <img src={logo} alt="" itemID='logo' className='logo' />
        <ul className="nav-menu">
          <div id=""></div>
          <li><AnchorLink className='anchor-link' href='#home'> <p onClick={() => setMenu("home")}>Home</p></AnchorLink>{menu === "home" ? <img src={underline} alt='' /> : <></>}</li>
          <li> <AnchorLink className='anchor-link' href='#about' ><p onClick={() => setMenu("about")}>About me</p></AnchorLink>{menu === "about" ? <img src={underline} alt='' /> : <></>}</li>
          <li><AnchorLink className='anchor-link' offset={50} href='#services'><p onClick={() => setMenu("services")}>Services</p></AnchorLink>{menu === "services" ? <img src={underline} alt='' /> : <></>}</li>
          <li><AnchorLink className='anchor-link' offset={50} href='#work'><p onClick={() => setMenu("work")}>Projects</p></AnchorLink>{menu === "work" ? <img src={underline} alt='' /> : <></>}</li>
          <li><AnchorLink className='anchor-link' offset={50} href='#contact'><p onClick={() => setMenu("contact")}>Contact</p></AnchorLink>{menu === "contact" ? <img src={underline} alt='' /> : <></>}</li>
        </ul>
        <div className="nav-connect">
          <AnchorLink className='anchor-link' offset={50} href='#contact'>Connect With me</AnchorLink>

        </div>
      </div>
    </>
  )
}

export default Navbar
